/** Colours the icon tile of a login denial screen. */
export enum LoginDenialTone {
	Info = 'info',
	Warning = 'warning',
}
